(function () {
  var STORAGE_KEY = 'maloby-recently-viewed';
  var MAX_STORED = 12;

  function readHandles() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeHandles(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) {
      /* localStorage unavailable, silently skip */
    }
  }

  function recordCurrentProduct(handle) {
    if (!handle) return;
    var list = readHandles().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle);
    writeHandles(list);
  }

  window.MalobyRecentlyViewed = {
    record: recordCurrentProduct,
    read: readHandles,
  };
})();

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.currentHandle = this.dataset.currentHandle || '';
    this.limit = parseInt(this.dataset.limit, 10) || 4;
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    this.container = this.querySelector('[data-recently-viewed-grid]');
    this.render();
  }

  async render() {
    const handles = window.MalobyRecentlyViewed.read()
      .filter((handle) => handle !== this.currentHandle)
      .slice(0, this.limit);

    if (handles.length === 0) {
      this.hidden = true;
      return;
    }

    const products = await Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      )
    );

    const validProducts = products.filter(Boolean);

    if (validProducts.length === 0) {
      this.hidden = true;
      return;
    }

    this.container.innerHTML = validProducts.map((product) => this.renderCard(product)).join('');
    this.hidden = false;
  }

  renderCard(product) {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const imageUrl = image ? image.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, '_400x.$1$2') : '';
    const price = this.formatMoney(product.price);
    const compareAtPrice =
      product.compare_at_price && product.compare_at_price > product.price
        ? this.formatMoney(product.compare_at_price)
        : null;

    return `
      <a href="${product.url}" class="recently-viewed__card">
        <span class="recently-viewed__image-wrapper">
          ${
            imageUrl
              ? `<img src="${imageUrl}" alt="${this.escapeHtml(product.title)}" loading="lazy" width="400" height="400">`
              : ''
          }
        </span>
        <span class="recently-viewed__title">${this.escapeHtml(product.title)}</span>
        <span class="recently-viewed__price">
          ${compareAtPrice ? `<s>${compareAtPrice}</s> ` : ''}${price}
        </span>
      </a>
    `;
  }

  formatMoney(cents) {
    return window.MalobyFormatMoney(cents, this.moneyFormat);
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
